import type { IScrollBarTheme } from '@visactor/vchart';

export const scrollBar: IScrollBarTheme = {
  horizontal: {
    height: 12,
    slider: {
      style: {
        fill: 'rgba(0,0,0,0.15)'
      }
    }
  },
  vertical: {
    width: 12,
    slider: {
      style: {
        fill: 'rgba(0,0,0,0.15)'
      }
    }
  }
};
